import { useState, useEffect } from 'react'

type CurrencyInputProps = {
  value: number | null // cents
  onChange: (cents: number) => void
}

function centsToDollars(cents: number | null): string {
  if (cents === null || cents === 0) return ''
  return (cents / 100).toFixed(2).replace(/\.00$/, '')
}

function dollarsToCents(input: string): number {
  const num = parseFloat(input)
  if (isNaN(num) || num < 0) return 0
  return Math.round(num * 100)
}

export default function CurrencyInput({ value, onChange }: CurrencyInputProps) {
  const [display, setDisplay] = useState(() => centsToDollars(value))

  // sync external value changes (e.g. form reset) without clobbering in-progress typing
  useEffect(() => {
    if (value !== dollarsToCents(display)) setDisplay(centsToDollars(value))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const handleChange = (raw: string) => {
    if (raw === '') {
      setDisplay('')
      onChange(0)
      return
    }
    // allow digits and one decimal point with up to 2 places
    if (!/^\d*\.?\d{0,2}$/.test(raw)) return
    setDisplay(raw)
    onChange(dollarsToCents(raw))
  }

  return (
    <div className="relative">
      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground text-lg font-medium">
        $
      </span>
      <input
        type="text"
        inputMode="decimal"
        value={display}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="0.00"
        className="w-full pl-9 pr-4 py-3 rounded-xl border border-input bg-card text-foreground text-lg placeholder:text-muted-foreground outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50"
      />
    </div>
  )
}
